module.exports = __webpack_public_path__ + "img/img-carousel-1.a46acd28.jpeg";